
import { PermissionsEnum } from '@/auth/interfaces';
import { EstadosPreagendamientoEnumChoice } from '@/shared';
import { useFetchPreagendamientos } from '@/shared/actions/erp';
import { GeneralTable, TableTabsScene } from '@/shared/components/ui';
// import { TABLE_CONSTANTS } from '@/shared/constants/ui';
import {
  useCheckPermissions,
  useTableServerSideFiltering,
} from '@/shared/hooks';
import { useTableFilter } from '@/shared/hooks/useTableFilter';
// AlertSeverityEnum,
import { IPreagendamiento } from '@/shared/interfaces';
// import { hasPermission } from '@/shared/utils';
import { useColumnsPreagendamientos } from '../../shared/hooks';
// import { Grid, IconButton } from '@mui/material';
// import { Undo } from '@mui/icons-material';
// import { useUiStore } from '@/store/ui';
// import {useState } from 'react';
// import { ConfirmUndoRefusedModal } from '../../shared/components';

export type PreagendamientoPendientePageProps = {
  estado_aceptacion?: boolean;
};


const PreagendamientoPendientePage: React.FC<
  PreagendamientoPendientePageProps
> = ({ estado_aceptacion = true }) => {

  //PERMISSIONS
  useCheckPermissions(PermissionsEnum.api_view_preagendamiento);
  
  //CONST
  // const returnUrlAgendamientosPyLPage =
  // ROUTER_PATHS.operaciones.agendamientoPyLNav;
  // const navigate = useNavigate();
  // const [showModalUndo, setShowModalUndo] = useState(false)
  // const [dataReversion, setDataReversion] = useState<Preagendamiento | null>(null)
  
  //GLOBALS
  // const setAlert = useUiStore(s => s.setAlert);
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  //const { user } = useAuthStore()

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: PreagendamientosPagingRes,
    isLoading,
    isRefetching,
  } = useFetchPreagendamientos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      estado_aceptacion: estado_aceptacion,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
      estado_preagendamiento_in: `${EstadosPreagendamientoEnumChoice.RECHAZADO},${EstadosPreagendamientoEnumChoice.PRERECHAZADO}`,
      //EstadosPreagendamientoEnumChoice.RECHAZADO,
    },
  });


  ///* mutations --------------------
  // const updatePreAgendamientoMutationOcupado =
  //   useUpdatePreagendamiento<PreagendamientoCambioEstado>({
  //     navigate,
  //     returnUrl: returnUrlAgendamientosPyLPage,
  //     enableSuccessAlert: false,
  //   });
  
  


  ///* handlers
  // const onEdit = async (preagendamiento: Preagendamiento | null) => {
  //   if(preagendamiento){
  //     updatePreAgendamientoMutationOcupado.mutate({
  //       id: preagendamiento.id_preagendamiento!,
  //       data: {
  //         estado_preagendamiento: EstadosPreagendamientoEnumChoice.EN_ESPERA
  //       },
  //     });
  
  //     setAlert(
  //       true,
  //       'Registro regresado a pre agendamientos.',
  //       AlertSeverityEnum.info
  //     );

  //   }else{
  //     setAlert(
  //       true,
  //       'El registro no existe, por favor, recargue la página.',
  //       AlertSeverityEnum.info
  //     );
  //   }

  // };

  ///* columns
  const { preagendamientoPendingReviewColumns } = useColumnsPreagendamientos();

  return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      searchInputText="por identificación"
      // onChangeRangeDate={onChangeRangeDate}
      cleanFilter={cleanFilter}
    >
      <GeneralTable<IPreagendamiento>
        columns={preagendamientoPendingReviewColumns}
        data={PreagendamientosPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={PreagendamientosPagingRes?.data?.count}
        enableColumnActions={false}
        enableEditing={false}
        // // actions ========
        // enableColumnActions={hasPermission(
        //   PermissionsEnum.api_change_preagendamiento
        // )}
        // actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        /* canEdit={hasPermission(PermissionsEnum.api_change_preagendamiento)}
        onEdit={onEdit}
        canDelete={false} */
        canEdit={false}
        canDelete={false}
        // enableEditing={estado_aceptacion}
        // showCustomActionBtnSpace={estado_aceptacion}
        // customActionBtnSpace={(value) => {
        //   return (
        //     <Grid container>
        //       <Grid item>
        //         <IconButton
        //           // onClick={() => onEdit(value)}
        //           onClick={() => {
        //             setDataReversion(value)
        //             setShowModalUndo(true)
        //           }}
                  
        //         >
        //           <Undo />
        //         </IconButton>
        //       </Grid>
        //     </Grid>
        //   )
        // }}

      />
      {/* <ConfirmUndoRefusedModal
        title={`Revertir Rechazo`}
        content={`Esta seguro que desea regresar el registro del cliente ${dataReversion?.prospecto_data?.razon_social} a Preagendamientos.`}
        open={showModalUndo}
        onClose={() => {
          setShowModalUndo(false)
          setDataReversion(null)
        }}
        onConfirm={
          () => {
            onEdit(dataReversion)
            setShowModalUndo(false)
          }
        }
      
      /> */}
    </TableTabsScene>
  );
};

export default PreagendamientoPendientePage;
